import { render, staticRenderFns } from "./MatchTable.vue?vue&type=template&id=c88365ea"
import script from "./MatchTable.vue?vue&type=script&lang=js"
export * from "./MatchTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports